import { Button, Chip } from "@dune/ui";
import { ColumnDef } from "@tanstack/react-table";
import { Eye } from "@untitled-ui/icons-react";

type PartnershipHistory = {
	effectiveDate: string;
	expirationDate: string;
	status: string;
	document: string;
};

export const partnershipHistoryColumns: ColumnDef<PartnershipHistory>[] = [
	{
		accessorKey: "effectiveDate",
		header: "Date d'effet",
	},
	{
		accessorKey: "expirationDate",
		header: "Date d'expiration",
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			return <Chip color={"green"} label={row.original.status} />;
		},
	},
	{
		accessorKey: "document",
		header: "Document(s)",
		cell: () => {
			return (
				<Button variant="outline">
					<Eye />
				</Button>
			);
		},
	},
];
